export default function isMiddleClickEvent(event) {
  return event.button === 1;
}
